import { Toggle } from '@warp-ds/react/components/toggle';
import type { ReactNode } from 'react';
import { thousandSeparated } from 'shared/util/formatting';

export type CheckboxOption = {
    value: string;
    text: ReactNode;
    count?: number;
};
export type CheckboxFilterProps = {
    id: string;
    title?: string;
    options: CheckboxOption[];
    checked?: string[];
    onChange: (value: string) => void;
};

export const SimpleCheckboxFilter = ({ id, title, options, checked, onChange }: CheckboxFilterProps) => {
    const createDisplayValue = (opt: CheckboxOption) => (
        <>
            {opt.text}
            {opt.count !== undefined && <span className="text-s s-text-subtle ml-8">({thousandSeparated(opt.count)})</span>}
        </>
    );

    const renderToggle = (opt: CheckboxOption) => (
        <Toggle
            type="checkbox"
            label={createDisplayValue(opt)}
            disabled={opt.count === 0}
            checked={checked?.includes(opt.value) ?? false}
            onChange={() => onChange(opt.value)}
            data-testid={`checkboxFilter-${id}-${opt.value}`}
            key={`checkboxFilter-${id}-${opt.value}`}
        />
    );

    return (
        <div className="space-y-8">
            {title && <h4 className="t5">{title}</h4>}
            {options.map(renderToggle)}
        </div>
    );
};
